import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden pb-[140%]">
        <img
          src={movie.poster}
          alt={`${movie.title}海报`}
          title={`${movie.title} - 色色影院影视推荐`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-900/80 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {movie.type === "movie" ? "电影" : "电视剧"}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center bg-primary-950/45 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-background-50">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1.5 truncate text-xs text-foreground-500">
          {movie.genres.slice(0, 3).join(" · ")}
        </p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="truncate pl-2">{movie.region}</span>
        </div>
      </div>
    </Link>
  );
}